// extracted by mini-css-extract-plugin
export var gray = "CountDown-module--gray--fmo83";
export var minutes = "CountDown-module--minutes--O-R4k";
export var minutes__text = "CountDown-module--minutes__text--4EbAC";
export var timeBlock = "CountDown-module--timeBlock--pzVlJ";
export var timeList = "CountDown-module--timeList--CE8Z6";
export var white = "CountDown-module--white--HQY8P";